<template>
  <div id="app">
    <router-view></router-view>
    <Loader />
    <Modal />
  </div>
</template>

<script>
import Loader from './components/Loader.vue'
import Modal from './components/Modal.vue'

const primaryColor = '#E4A144'

const partners = {
  autopay: {
    primaryColor: '#199BFA'
  }
}

export default {
  components: {
    Loader,
    Modal
  },
  name: 'App',
  mounted () {
    let urlParams = new URLSearchParams(window.location.search)
    this.getPartnerProperties()
    if (urlParams.has('policy')) {
      if (urlParams.has('partner') && urlParams.get('partner')) {
        this.isIframe()
      }
      this.$router.push('/policy-finish')
    } else {
      this.$router.push('/')
    }
  },

  methods: {
    checkIsInIframe (id) {
      let _this = this
      _this.$store.commit('setLoader', true)

      _this.axios
        .post('/wp-json/travel/v1/checkIsInIframe', {
          id: id
        })
        .then(function (response) {
          if (response && response.data) {
            if (response.data == 1) {
              _this.isIframe()
            }
          }
        })
        .catch(thrown => {
          if (!this.axios.isCancel(thrown)) {
            console.log(thrown)
            _this.$store.commit('setLoader', false)
            _this.$store.commit('setShowModal', true)
          }
        })
    },
    sendNewSizesMessage (calculatorSizes) {
      if (!parent?.postMessage) return
      parent.postMessage({ calculatorSizes }, '*')
    },

    calculatorResizeResolver (entries) {
      const calculatorSizes = entries[0].target.getBoundingClientRect()
      this.sendNewSizesMessage(calculatorSizes)
    },
    getPartnerProperties () {
      if (window !== window.parent) {
        this.isIframe()
      } else {
        document.documentElement.style.setProperty(
          '--primary-color',
          primaryColor
        )
      }
    },
    isIframe () {
      let urlParams = new URLSearchParams(window.location.search)
      let currentPartnerProperties = ''
      if (urlParams.has('partner')) {
        if (
          Object.prototype.hasOwnProperty.call(
            partners,
            urlParams.get('partner')
          )
        ) {
          currentPartnerProperties = partners?.[urlParams.get('partner')]
          this.$store.commit('setPartner', urlParams.get('partner'))
        }
      }

      document.body.setAttribute('data-is-in-iframe', 'true')
      this.$store.commit('setIsInIframe', true)

      document.documentElement.style.setProperty(
        '--primary-color',
        currentPartnerProperties?.primaryColor
          ? currentPartnerProperties.primaryColor
          : primaryColor
      )

      const resizeObserver = new ResizeObserver(this.calculatorResizeResolver)
      resizeObserver.observe(document.body)
    }
  }
}
</script>

<style>
body[data-is-in-iframe='true'] .bg-orange-100,
body[data-is-in-iframe='true'] .btn-autopay {
  background-color: var(--primary-color);
}
body[data-is-in-iframe='true'] .comparer-button:hover {
  color: black;
}
body[data-is-in-iframe='true'] #comparer_form,
body[data-is-in-iframe='true'] section.bg-gray-100 {
  background: white;
}
body[data-is-in-iframe='true'] #comparer_header,
body[data-is-in-iframe='true'] .policy-finish-check,
body[data-is-in-iframe='true'] #comaparer_steps,
body[data-is-in-iframe='true'] #comparer_chat,
body[data-is-in-iframe='true'] footer,
body[data-is-in-iframe='true'] #wpadminbar,
body[data-is-in-iframe='true'] #rasaWebchatPro {
  display: none;
}
</style>
